import { XMarkIcon } from "assets";
import React, { useEffect, useRef } from "react";

interface Props {
  children: React.ReactNode;
  setShowCard: React.Dispatch<React.SetStateAction<boolean>>;
  showCard: boolean;
}

const Card: React.FC<Props> = ({ children, setShowCard, showCard }) => {
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target as Node)
      ) {
        setShowCard(false);
      }
    };

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        setShowCard(false);
      }
    };

    if (showCard) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("keydown", handleKeyDown);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [showCard, setShowCard]);
  if (!showCard && !setShowCard) {
    return <></>;
  }

  return (
    <>
      <div
        className="fixed inset-0 z-50 flex items-center justify-center"
        ref={modalRef}
      >
        <div className="p-6 bg-white border border-primary-500 rounded-lg w-2/5 max-h-[90%] h-fit shadow-lg relative transition-all duration-300 ease-in-out">
          <button
            onClick={() => setShowCard(false)}
            className="absolute border-2 border-primary-500 p-1 top-3 right-3 text-primary-900 hover:text-red-800 rounded-full"
          >
            <XMarkIcon className=" size-4 text-black hover:text-red-700 transition-all duration-300 ease-in-out" />
          </button>
          {children}
        </div>
      </div>
    </>
  );
};

export default Card;
